{
  "rowTypeName": {
    "companies": "Companies",
    "contacts": "Contacts",
    "key_activities": "Key Activities",
    "projects_opportunities": "Projects Opportunities",
    "opportunities": "Opportunities",
    "generic_items": "Items",
    "key_activity_dashboard": "Key Activities"
  },
  "actions": {
    "add_opportunity": "Create Opportunity",
    "add_activity": "Create Activity",
    "add_company": "Add Company",
    "add_contact": "Add Contact",
    "add_generic_item": "Create Item",
    "bulk_edit": "Bulk Edit",
    "bulk_edit_aria_label": "Bulk Edit selected items",
    "add_to_list": "Add to List",
    "bulk_add_to_list_aria_label": "Add selected items to list",
    "bulk_remove_aria_label": "Bulk remove selected items",
    "edit_custom_field_header": "Edit Custom Fields"
  },
  "view_types": {
    "list": "List View",
    "kanban": "Kanban View",
    "calendar": "Calendar View",
    "timeline": "Timeline View"
  },
  "list_types": {
    "basic": "Basic",
    "large": "Large"
  },
  "share": {
    "invite_member": "Invite Member"
  },
  "views": {
    "views": "Views",
    "delete_view": {
      "title": "Delete View",
      "label": "Delete {{viewName}} View",
      "confirm_title": "Are you sure?",
      "confirm_content": "Click confirm to delete view"
    },
    "actions": "View actions for {{viewName}}",
    "default_view": "Default View",
    "create_view": "Create View",
    "edit_view": {
      "title": "Edit View",
      "label": "Edit {{viewName}} View"
    },
    "share": {
      "title": "Share View",
      "label": "Share {{viewName}} View",
      "success_message": "List View has been successfully shared. We will notify the recipients."
    }
  },
  "bulk_actions": {
    "confirm_title": "Are you sure?",
    "confirm_content": "The {{rowTypeName}} will be removed from this list."
  },
  "inline_actions": {
    "edit_custom_field": "Edit Custom Field",
    "remove": "Remove"
  },
  "more_actions": {
    "more": "More",
    "large_list_view_title": "Large List View",
    "large_list_view_description": "Improved performance, limited search, sort and filters.",
    "switch_list_type": "Switch to {{listType}} List View",
    "switch_list_type_loading": "Loading Table..."
  },
  "export": {
    "title": "Export",
    "confirmationModal": {
      "content": "Exporting a large list will include all {{rowTypeName}} and may take some time. To speed up the process, consider applying a filter. Are you sure you want to proceed with exporting all {{rowTypeName}} without any filters?"
    }
  },
  "form": {
    "searching": "Searching...",
    "start_typing_search": "Start typing to search",
    "placeholder": "Type and press Enter"
  },
  "grid": {
    "columns": "Columns"
  },
  "rollup_fields": {
    "empty_state": {
      "title": "No Rollup Fields Yet",
      "description": "To begin, add a rollup field to aggregate and display the information most relevant to your workflow"
    },
    "modal": {
      "header": "Rollup Fields",
      "caption": "Rollup field lets you aggregate data from linked items into a single view."
    },
    "actions": {
      "rename_tooltip": "Rename",
      "delete_tooltip": "Delete",
      "rename_aria_label": "Rename rollup field {{name}}",
      "delete_aria_label": "Delete rollup field {{name}}"
    },
    "delete": {
      "confirm_title": "Are you sure?",
      "confirm_content": "Click confirm to delete this rollup field"
    },
    "update": {
      "modal_header": "Rename Rollup Field",
      "name_label": "Rollup Name",
      "validation_required": "Please enter rollup field name"
    },
    "create": {
      "button_text": "Add Rollup",
      "modal_header": "Add Rollup",
      "modal_caption": "Use Rollup to aggregate information from linked columns. Learn More",
      "name_label": "Rollup Name",
      "source_label": "Source",
      "source_field_aria_label": "Select source list",
      "source_field_placeholder": "Type to search list",
      "conditions_label": "Apply based on conditions",
      "conditions_tooltip": "Only rows that meet your selected criteria will be included.",
      "validation_name_required": "Please type rollup field name",
      "validation_source_required": "Please select source list",
      "validation_operation_required": "Operation Type is required"
    },
    "source": {
      "opportunities": "Opportunities"
    },
    "table": {
      "columns": {
        "rollup_field_name": "Rollup Field Name",
        "source": "Source",
        "column_field": "Column Field",
        "operation": "Operation",
        "condition": "Condition",
        "value": "Value",
        "actions": "Actions"
      }
    }
  }
}
